import React, { useState } from "react";
import { Link } from "react-router-dom";
import Image1 from "../Home/img_project/webp/13Façade architecturale moderne de la gare Rabat Agdal avec habillage et éclairage intégré.webp";
import Image2 from "../Home/img_project/webp/2.webp";
import Image3 from "../Home/img_project/webp/34Plafond architectural moderne.webp";
import Image4 from "../Home/img_project/webp/4.webp";
import Image5 from "../Home/img_project/webp/19Auvent textile architectural pour espace public et zones piétonnes.webp";
import Image6 from "../Home/img_project/webp/23Architecture textile modulaire avec toiles tendues et structure métallique – design contemporain et ombrage extérieur.webp";

const projects = [
  {
    id: 1,
    title: "Gare Rabat Agdal",
    image: Image1,
    heading: "Gare Rabat Agdal – Solutions lumineuses",
    text: "Réalisation d’une conception lumineuse innovante alliant esthétique, confort visuel.",
    text2: "Solutions UNIK SYSTEM : Éclairage architectural, mise en lumière des façades, solutions LED intérieures.",
    link: "/ProjectUnikSystem1"
  },
  {
    id: 2,
    title: "Piscine Olympique de Rabat",
    image: Image2,
    heading: "Piscine Olympique – Plafond acoustique haute performance",
    text: "Installation d’un plafond tendu intégrant des textiles acoustiques haute performance.",
    text2: "Solutions UNIK SYSTEM : plafonds tendus, traitement acoustique, résistance à l’humidité.",
    link: "/ProjectUnikSystem2"
  },
  {
    id: 3,
    title: "Salon VIP Stade Moulay Abdellah",
    image: Image4,
    heading: "Salon VIP – Espace premium & plafond lumineux",
    text: "Création d’un espace VIP exclusif avec plafond lumineux rétro-éclairé.",
    text2: "Solutions UNIK SYSTEM : plafonds lumineux, rétroéclairage, design premium.",
    link: "/ProjectUnikSystem3"
  },
  {
    id: 4,
    title: "Grand Théâtre Mohammed VI",
    image: Image3,
    heading: "Grand Théâtre Mohammed VI – Plafond architectural",
    text: "Plafond rétro-éclairé de plus de 2 000 m² pour un projet emblématique.",
    text2: "Solutions UNIK SYSTEM : toiles translucides, architecture de prestige.",
    link: "/ProjectUnikSystem4"
  },
  {
    id: 5,
    title: "Canopée – École Américaaine",
    image: Image5,
    heading: "Canopée – École Américaaine",
    text: "Réalisation : Canopée architecturale extérieure.",
    text2: "Solutions UNIK SYSTEM : Voiles d’ombrage / Pergolas.",
    link: "/ProjectUnikSystem5"
  },
  {
    id: 6, 
    title: "École OFPPT Guelmim",
    image: Image6,
    heading: "École OFPPT Guelmim Structure d’ombrage",
    text: "Réalisation : Structure d’ombrage architecturale extérieure.",
    text2: "Solutions UNIK SYSTEM : Structures métallo-textiles.",
    link: "/ProjectUnikSystem6"
  },
];

const Section4 = () => {
  const [activeId, setActiveId] = useState(projects[0].id);
  const active = projects.find(p => p.id === activeId);

  return (
    <section className="projects-section">
      <div className="container-xxl">

        {/* HEADER */}
        <div className="projects-header">
          <h2 className="section-titles" data-aos="fade-up"><span className="section-titles-2">NOS</span> projets</h2>
          <p data-aos="fade-up">Découvrez nos réalisations architecturales emblématiques</p>
        </div>

        <div className="projects-layout">

          {/* LEFT */}
          <div data-aos="fade-up" className="projects-menu">
            {projects.map(p => (
              <button
                key={p.id}
                
                className={`menu-item ${p.id === activeId ? "active" : ""}`}
                onClick={() => setActiveId(p.id)}
              >
                <span className="dot" />
                {p.title}
              </button>
            ))}
          </div>

          {/* RIGHT */}
          <div className="projects-content">
            <div className="project-card">
              <div className="project-image"
                    data-aos="fade-up"
              >
                <img src={active.image} alt={active.title} loading="lazy" />
              </div>

              <div className="project-info" data-aos="fade-up">
                <h3>{active.heading}</h3>
                <p>{active.text}</p>
                <p  className="muted">{active.text2}</p>

                <Link  to={active.link} className="btn-project">
                  Découvrir le projet
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Section4;
